<template>
    <section class="mb-3 padding-vertical-content lightgray-content mb-lg-4">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="nombre">{{$t("formularios.nombre_completo") + " *"}}</label>
                                    <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                                        <input
                                            data-cy="nombre"
                                            id="nombre"
                                            type="text"
                                            :class="'form-control rounded-pill ' + (errors[0] ? 'is-invalid' : '')"
                                            :placeholder="$t('formularios.nombre_completo')"
                                            v-model="acreditacion_local.nombre"
                                        />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <DocumentoTipo
                                    v-model="acreditacion_local.tipoDocumento"
                                    :index="0"
                                />
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <DocumentoValor
                                    data-cy="dni"
                                    v-model="acreditacion_local.dni"
                                    :type="acreditacion_local.tipoDocumento"
                                    :index="0"
                                />
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="email">{{$t("formularios.email") + " *"}}</label>
                                    <ValidationProvider name="email" rules="required" v-slot="{ errors }">
                                        <input 
                                            id="email" 
                                            type="text" 
                                            :class="'form-control rounded-pill ' + (errors[0] ? 'is-invalid' : '')"
                                            :placeholder="$t('formularios.email')" 
                                            v-model="acreditacion_local.email"
                                        />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="telefono">{{$t("formularios.telefono") + " *"}}</label>
                                    <ValidationProvider name="telefono" rules="required" v-slot="{ errors }">
                                        <input 
                                            id="telefono" 
                                            type="text" 
                                            :class="'form-control rounded-pill ' + (errors[0] ? 'is-invalid' : '')"
                                            :placeholder="$t('formularios.telefono')" 
                                            v-model="acreditacion_local.telefono"
                                        />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="medio">{{$t("formularios.medio") + " *"}}</label>
                                    <ValidationProvider name="medio" rules="required" v-slot="{ errors }">
                                        <input 
                                            id="medio" 
                                            type="text" 
                                            :class="'form-control rounded-pill ' + (errors[0] ? 'is-invalid' : '')"
                                            :placeholder="$t('formularios.medio')" 
                                            v-model="acreditacion_local.medio"
                                        />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="funcion">{{$t("formularios.funcion") + " *"}}</label>
                                    <ValidationProvider name="funcion" rules="required|max:20" v-slot="{ errors }">
                                        <input 
                                            id="funcion" 
                                            type="text" 
                                            :class="'form-control rounded-pill ' + (errors[0] ? 'is-invalid' : '')"
                                            :placeholder="$t('formularios.funcion')" 
                                            v-model="acreditacion_local.funcion"
                                        />
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label for="evento">{{$t("formularios.seleciona_el_evento") + " *"}}</label>
                                    <ValidationProvider name="evento" rules="required" v-slot="{ errors }">
                                        <multiselect
                                            v-model="event"
                                            :options="eventos"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            placeholder="Seleccione el evento"
                                            label="name"
                                            track-by="id"
                                            id="slect-evento"
                                            :class="'form-control rounded-pill ' + (errors[0] ? 'is-invalid' : '')"
                                        />
                                        <span v-if="errors[0]" class="error invalid-feedback is-invalid" style="display: block;">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <Button
                                id="terminar"
                                type="submit"
                                :label="$t('formularios.continuar')"
                            />
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    import { ref, computed, onMounted } from 'vue';
    import store from '@/store';
    import DocumentoTipo from '@/components/common/DocumentoTipo.vue';
    import DocumentoValor from '@/components/common/DocumentoValor.vue';
    import { useGetEventos } from '@/composables/front/common/useGetEventos.js';
    import Button from '@/modules/ui/Button.vue';

    const props = defineProps({
        events: {
            type: Object,
            default: () => ({})
        },
        acreditacion: {
            type: Object,
            default: () => ({})
        }
    });

    const emit = defineEmits(['submit']);

    const { eventos, getEventos } = useGetEventos();

    const observer = ref(null);
    const event = ref({});

    const configuracion = computed(() => store.getters.getConfig);

    const submit = async() => {
        const isValid = await observer.value.validate();
        if (isValid) {
            acreditacion_local.value.evento_id = event.value.id;
            emit('submit', acreditacion_local.value);
        }
    };

    const acreditacion_local = ref({...props.acreditacion});

    onMounted(() => {
        getEventos(configuracion.value.hash_teatro);
    });
</script>

<style scoped>
    /* Input styles */
    .form-control.rounded-pill {
        border-radius: 50px;
        padding: 0.5rem 1rem;
        height: auto;
        min-height: 38px;
        width: 100%;
        font-size: 14px;
    }

    /* Multiselect wrapper styles */
    .multiselect.form-control.rounded-pill {
        width: 100%;
        border-radius: 50px;
        border: 1px solid #ced4da;
        min-height: 38px;
        height: auto;
        background-color: #fff;
        padding: 0;
        font-size: 14px;
    }

    .multiselect.form-control.rounded-pill:focus-within {
        border-color: #80bdff;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    .multiselect.form-control.rounded-pill.is-invalid {
        border-color: #dc3545;
    }

    .multiselect.form-control.rounded-pill.is-invalid:focus-within {
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }

    /deep/ .multiselect.form-control.rounded-pill > .multiselect__tags {
        background-color: white;
        border: none;
        border-radius: 50px;
        min-height: 36px;
        padding: 0.375rem 2.5rem 0.375rem 0.75rem;
        font-size: 14px;
    }

    /deep/ .multiselect.form-control.rounded-pill > .multiselect__tags > .multiselect__single {
        background-color: transparent;
        padding: 0;
        margin: 0;
        line-height: 1.5;
        font-size: 14px;
        color: #495057;
    }

    /deep/ .multiselect.form-control.rounded-pill > .multiselect__select {
        height: 36px;
        width: 36px;
        padding: 0;
    }

    /deep/ .multiselect.form-control.rounded-pill > .multiselect__select:before {
        border: none;
        content: "▼";
        font-size: 10px;
        color: #495057;
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
    }

    /deep/ .multiselect.form-control.rounded-pill > .multiselect__content-wrapper {
        right: 0;
        border-radius: 0.5rem;
        border: 1px solid #ced4da;
        margin-top: 4px;
    }

    /* Responsive mobile styles */
    @media (max-width: 576px) {
        .form-control.rounded-pill {
            border-radius: 30px;
            padding: 0.4rem 0.75rem;
            min-height: 36px;
            font-size: 13px;
        }

        .multiselect.form-control.rounded-pill {
            border-radius: 30px;
            min-height: 36px;
            font-size: 13px;
        }

        /deep/ .multiselect.form-control.rounded-pill > .multiselect__tags {
            border-radius: 30px;
            min-height: 34px;
            padding: 0.25rem 2rem 0.25rem 0.5rem;
            font-size: 13px;
        }

        /deep/ .multiselect.form-control.rounded-pill > .multiselect__tags > .multiselect__single {
            font-size: 13px;
        }

        /deep/ .multiselect.form-control.rounded-pill > .multiselect__select {
            height: 34px;
            width: 34px;
        }

        /deep/ .multiselect.form-control.rounded-pill > .multiselect__select:before {
            right: 8px;
            font-size: 8px;
        }
    }
</style>
